import { jsonApi } from '@models/jsonApi';

jsonApi.define('dms/variable_category', {
  label: '',
  variables: {
    jsonApi: 'hasMany',
    type: 'dms/variable',
  },
});
